module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/office/office.component.css
// module id = ./src/app/master/office/office.component.css
// module chunks = main